import { inject, Inject, Pipe, PipeTransform } from '@angular/core';

import { CHANNEL_LINK_TRANSLATIONS, channelLinkTranslations } from '@usheru-hff/sdk/channel';

@Pipe({
  name: 'channelLinkLocalize',
  standalone: true,
  pure: true
})
export class ChannelLinkLocalizePipe implements PipeTransform {
  customTranslations = inject(CHANNEL_LINK_TRANSLATIONS, { optional: true }) as Record<string, string>;

  transform(key: string, placeholder?: string): string {
    const localized = this.customTranslations?.[key] || channelLinkTranslations[key];
    const fallback = placeholder || key;

    return localized || fallback;
  }
}
